// extracted by mini-css-extract-plugin
module.exports = {"title":"e_rt","hidden":"e_st","showMore":"e_tt","features":"e_ut","featuresOpened":"e_vt","colorPositive":"e_wt","colorNegative":"e_xt","buttonOpen":"e_yt","hiddenDesktop":"e_zt"};